import { render, staticRenderFns } from "./ticker-popover.vue?vue&type=template&id=d90d1e76&scoped=true"
import script from "./ticker-popover.vue?vue&type=script&lang=js"
export * from "./ticker-popover.vue?vue&type=script&lang=js"
import style0 from "./ticker-popover.vue?vue&type=style&index=0&id=d90d1e76&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90d1e76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d90d1e76')) {
      api.createRecord('d90d1e76', component.options)
    } else {
      api.reload('d90d1e76', component.options)
    }
    module.hot.accept("./ticker-popover.vue?vue&type=template&id=d90d1e76&scoped=true", function () {
      api.rerender('d90d1e76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/desktop/ticker-popover.vue"
export default component.exports